window.addEventListener("load", function() {
    const handleSwymButtonClick = () => {
        const swymButtons = document.querySelectorAll('.swym-button');
        swymButtons.forEach(button => {
            button.addEventListener('click', function() {
                const overlay = document.querySelector('.swym-popup-overlay');
                if (overlay) {
                    overlay.style.display = 'block';
                }
            });
        });
    };

    // MutationObserverの設定
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                handleSwymButtonClick(); // Re-apply event listeners
            }
        }
    });

    // 監視対象とするDOM要素を指定
    observer.observe(document.body, { childList: true, subtree: true });

    // 初回実行
    handleSwymButtonClick();
});


